const Emitter = require('mn-utils/Emitter');
const filter = require('mn-utils/filter');
const find = require('mn-utils/find');
const map = require('mn-utils/map');
const {get} = require('../http');

const widgets$ = new Emitter([
  {
    id: 'f3d49fd4-2a92-4d92-a711-19fbcb67e390',
    secret: 'f3d49fd4-2a92-4d92-a711-19fbcb67e391',
    website: 'https://test.test',
    engine: 'wordpress',
    status: 'ordered',
    threshold: 10000,
  },
  {
    id: 'f3d49fd4-2a92-4d92-a711-19fbcb67e391',
    secret: 'f3d49fd4-2a92-4d92-a711-19fbcb67e391',
    website: 'https://example.test',
    engine: 'wordpress',
    status: 'ordered',
    threshold: 10000,
  },
]);
const {
  emit,
  getValue,
} = widgets$;
let __lastId = require('../../utils/getLastIdByEmitter')(widgets$);


export function apiAppList(params) {
  return get('/f2c/v1/console/app/list', params, () => {
    return {
      list: getValue(),
    };
  });
}
export function apiAppGet(params) {
  return apiRequest('/v1/console/app/get', params, () => {
    return {
      ...find(getValue(), ['id', params.id]),
      secret: 'e1e06b8a-3ba0-4146-a25e-23cb7c89178b',
    };
  });
}
export function apiAppAdd(params) {
  return apiRequest('/v1/console/app/add', params, (params) => {
    const {
      engine,
    } = params;
    const createdList = map(params.websites, (website) => {
      return {
        id: '' + __lastId++,
        website,
        engine,
      };
    });
    emit([
      ...createdList,
      ...getValue(),
    ]);
    return {
      list: createdList,
    };
  });
}
export function apiAppEdit(params) {
  return apiRequest('/v1/console/app/edit', params, () => {
    const {
      id,
    } = params;
    let _data;
    emit(map(getValue(), (item) => {
      return id === item.id ? (_data = {
        ...item,
        ...params,
      }) : item;
    }));
    return _data;
  });
}
export function apiAppRemove(params) {
  return apiRequest('/v1/console/app/remove', params, () => {
    const {
      id,
    } = params;
    emit(filter(getValue(), (v) => v.id !== id));
  });
}


export function apiAppNotificationHeaderList(params) {
  return apiRequest('/v1/console/app/notification-http-header/list', params);
}
export function apiAppNotificationHeaderAdd(params) {
  return apiRequest('/v1/console/app/notification-http-header/add', params);
}
export function apiAppNotificationHeaderEdit(params) {
  return apiRequest('/v1/console/app/notification-http-header/update', params);
}
export function apiAppNotificationHeaderRemove(params) {
  return apiRequest('/v1/console/app/notification-http-header/delete', params);
}

export function apiAppThresholdUpdate(params) {
  return apiRequest('/v1/console/app/threshold/update', params);
}
